import React from 'react'
import { css } from 'glamor'
import { mUp } from '../../theme/mediaQueries'

import {
  serifTitle16,
  serifTitle20,
  serifRegular15,
  serifRegular17,
  sansSerifRegular14,
  sansSerifRegular12,
  sansSerifMedium14,
  sansSerifMedium12
} from '../Typography/styles'
import { useColorContext } from '../Colors/useColorContext'
import { FigureImage } from '../Figure'

const styles = {
  title: css({
    ...serifTitle16,
    [mUp]: {
      ...serifTitle20
    }
  }),
  titleInline: css({
    ...serifTitle16,
    marginBottom: 0
  }),
  lead: css({
    ...serifRegular15,
    [mUp]: {
      ...serifRegular17
    }
  }),
  label: css({
    marginTop: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }),
  labelRegular: css({
    ...sansSerifRegular12,
    [mUp]: {
      ...sansSerifRegular14
    }
  }),
  labelMedium: css({
    ...sansSerifMedium12,
    [mUp]: {
      ...sansSerifMedium14
    }
  }),
  plainlink: css({
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'pointer'
  })
}

const DefaultLink = ({ children }) => children

const SeriesNavTileContent = ({
  t,
  inline,
  episode,
  current,
  ActionBar,
  Link = DefaultLink,
  onEpisodeClick,
  aboveTheFold
}) => {
  const [colorScheme] = useColorContext()
  const imageProps = inline
    ? episode.image &&
      FigureImage.utils.getResizedSrcs(episode.image, 300, true)
    : episode.image &&
      FigureImage.utils.getResizedSrcs(episode.image, 600, true)

  const isLink = episode.document && episode.document?.meta?.path && !current

  const LinkContainer = ({ children }) =>
    isLink ? (
      <Link href={episode.document.meta.path} passHref>
        <a {...styles.plainlink} onClick={onEpisodeClick}>
          {children}
        </a>
      </Link>
    ) : (
      <>{children}</>
    )

  if (inline) {
    return (
      <LinkContainer>
        <p
          {...styles.label}
          {...(current ? styles.labelMedium : styles.labelRegular)}
          {...colorScheme.set('color', 'text')}
        >
          {current ? `${t('styleguide/SeriesNav/current')} ` : ''}
          {episode.label}
        </p>
        {imageProps ? (
          <FigureImage aboveTheFold={aboveTheFold} {...imageProps} alt='' />
        ) : null}
        <h2 {...styles.titleInline} {...colorScheme.set('color', 'text')}>
          {episode.title}
        </h2>
      </LinkContainer>
    )
  }

  return (
    <>
      <LinkContainer>
        <p
          {...styles.label}
          {...(current ? styles.labelMedium : styles.labelRegular)}
          {...colorScheme.set('color', 'text')}
        >
          {current ? 'Sie lesen: ' : ''}
          {episode.label}
        </p>
        {imageProps ? (
          <FigureImage aboveTheFold={aboveTheFold} {...imageProps} alt='' />
        ) : null}
        <h2 {...styles.title} {...colorScheme.set('color', 'text')}>
          {episode.title}
        </h2>
        <p {...styles.lead} {...colorScheme.set('color', 'text')}>
          {episode.lead}
        </p>
      </LinkContainer>
      {!!episode.document && !!ActionBar && (
        <ActionBar mode='seriesEpisode' document={episode.document} />
      )}
    </>
  )
}

export default SeriesNavTileContent
